import Reveal from "../components/Reveal";

export default function Privacy() {
  return (
    <div>
      <section className="pt-40 md:pt-48 pb-12 container-luxe">
        <div className="eyebrow mb-6">Privacy Policy</div>
        <h1 className="font-serif text-5xl md:text-7xl leading-[0.95] tracking-tight">Your privacy, <span className="italic">respected</span>.</h1>
        <p className="mt-6 text-foreground/55 text-sm">Last updated: February 2026</p>
      </section>

      <section className="container-luxe pb-24 max-w-3xl">
        <Reveal>
          <article className="prose-luxe space-y-10 text-foreground/80 leading-[1.85]">
            <div>
              <h2 className="font-serif text-3xl mb-4">1. Who we are</h2>
              <p>Voyage Luxe Travel Atelier ("we", "us", "our") is a private destination management company registered in New Delhi, India. We collect and process personal information solely to design and deliver bespoke travel journeys.</p>
            </div>
            <div>
              <h2 className="font-serif text-3xl mb-4">2. What we collect</h2>
              <p>When you submit an inquiry, subscribe to our journal, or correspond with our concierge desk, we may collect: your name, email, phone number, travel preferences, dates, and budget range. We do not collect payment information through our website — all transactions are handled through secure third-party processors.</p>
            </div>
            <div>
              <h2 className="font-serif text-3xl mb-4">3. How we use it</h2>
              <p>Your information is used exclusively to respond to your inquiry, design your journey, and (with your consent) send occasional curated travel correspondence. We will never sell, rent, or share your information with third parties for marketing purposes.</p>
            </div>
            <div>
              <h2 className="font-serif text-3xl mb-4">4. Cookies</h2>
              <p>We use a minimal set of cookies to remember your theme preference (light or dark) and to understand which pages our guests find most valuable. You may decline non-essential cookies at any time.</p>
            </div>
            <div>
              <h2 className="font-serif text-3xl mb-4">5. Your rights</h2>
              <p>You may at any time request a copy of the data we hold about you, request correction, or request deletion. Write to <a className="text-accent underline-offset-4 hover:underline" href="mailto:concierge@voyageluxe.com">concierge@voyageluxe.com</a>.</p>
            </div>
            <div>
              <h2 className="font-serif text-3xl mb-4">6. Contact</h2>
              <p>Voyage Luxe Travel Atelier<br />11 Aurangzeb Road, New Delhi 110011, India<br />+91 98 1000 8888 · concierge@voyageluxe.com</p>
            </div>
          </article>
        </Reveal>
      </section>
    </div>
  );
}
